// extracted by mini-css-extract-plugin
module.exports = {"excludedWords":"excludedWords__JX71Q","input":"input__HMCcy"};